import React from 'react';

import { useField, useFormikContext } from 'formik';
import { Autocomplete, TextField } from '@mui/material';

import { Player } from 'src/models';

interface Props {
  id: string;
  options: Player[];
  label: string;
  disabled?: boolean;
  player?: Player;
}

const PlayersAutocomplete = ({
  id,
  options,
  label,
  disabled,
  player,
}: Props): JSX.Element => {
  const { setFieldValue } = useFormikContext<{}>();
  const [, meta] = useField<{}>(id);

  return (
    <Autocomplete
      disablePortal={true}
      id={id}
      options={options}
      getOptionLabel={(option) =>
        option.rank
          ? `${option.fullName} (${option.type} - Top Scorer)`
          : `${option.fullName} (${option.type})`
      }
      isOptionEqualToValue={(option, value) => option.id === value.id}
      onChange={(e, value) => {
        setFieldValue(id, value);
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          error={!!(meta.touched && meta.error)}
        />
      )}
      value={player}
      defaultValue={null}
      disabled={disabled}
    />
  );
};

export default PlayersAutocomplete;
